// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.temperature-trend {
  padding: var(--spacing-lg);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: var(--spacing-md);
  flex-wrap: wrap;
  gap: var(--spacing-sm);
  align-items: center;
}

.title-section {
  display: flex;
  flex-direction: column;
}

.card-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.card-subtitle {
  font-size: 0.75rem;
  color: var(--text-muted);
}

/* View Toggle */
.view-toggle {
  display: flex;
  background: var(--bg-secondary);
  border-radius: var(--radius-sm); 
  padding: 2px;
  border: 1px solid var(--border-color);
}

.toggle-btn {
  padding: var(--spacing-xs) var(--spacing-sm);
  background: transparent;
  border: none;
  color: var(--text-muted);
  font-size: 0.75rem;
  cursor: pointer;
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
  white-space: nowrap;
  min-width: fit-content;
}

.toggle-btn:hover {
  color: var(--text-primary);
}

.toggle-btn.active {
  background: var(--accent-blue);
  color: white;
}

/* History Range Selector */
.history-range-selector {
  display: flex;
  gap: var(--spacing-xs);
  margin-bottom: var(--spacing-md);
}

.range-btn {
  padding: var(--spacing-xs) var(--spacing-md);
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  color: var(--text-muted);
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
}

.range-btn:hover {
  color: var(--text-primary);
  border-color: var(--accent-cyan);
}

.range-btn.active {
  background: var(--accent-cyan);
  color: white;
  border-color: var(--accent-cyan);
}

/* History Loading */
.history-loading {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) 0;
  color: var(--text-muted);
  font-size: 0.8rem;
}

.spinner.small {
  width: 16px;
  height: 16px;
  border-width: 2px;
}

/* Statistics Row */
.stats-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-sm);
  margin-bottom: var(--spacing-md);
}

.stat-card {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm);
  background: var(--bg-secondary);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-color);
}

.stat-card.trend.rising {
  border-color: var(--accent-green);
  background: rgba(16, 185, 129, 0.1);
}

.stat-card.trend.falling {
  border-color: var(--accent-blue);
  background: rgba(59, 130, 246, 0.1);
}

.stat-icon {
  font-size: 1.25rem;
}

.stat-info {
  display: flex;
  flex-direction: column;
}

.stat-value {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.2;
}

.stat-label {
  font-size: 0.65rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

/* Chart Container */
.chart-container {
  flex: 1 1;
  display: flex;
  gap: var(--spacing-sm);
  min-height: 150px;
}

.y-axis {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: var(--spacing-sm) 0;
  min-width: 40px;
}

.y-label {
  font-size: 0.7rem;
  color: var(--text-muted);
  text-align: right;
  font-family: 'Monaco', 'Consolas', monospace;
}

.chart-area {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  position: relative;
}

.chart-svg {
  flex: 1 1;
  width: 100%;
  overflow: visible;
}

/* Grid Lines */
.grid-lines line {
  stroke: var(--border-color);
  stroke-width: 0.3;
  stroke-dasharray: 2, 4;
}

/* Chart Paths */
.area-path {
  transition: d var(--transition-normal);
}

.temp-line {
  filter: drop-shadow(0 0 4px rgba(6, 182, 212, 0.5));
  transition: d var(--transition-normal);
}

.high-line,
.low-line {
  opacity: 0.7;
}

/* Data Points */
.data-point-group {
  transition: transform var(--transition-fast);
}

.data-point {
  transition: r var(--transition-fast);
}

.point-glow {
  transition: opacity var(--transition-fast), r var(--transition-fast);
}

.chart-svg:hover .data-point {
  r: 2.5;
}

.chart-svg:hover .point-glow {
  r: 5;
  opacity: 0.5;
}

/* X-Axis */
.x-axis {
  display: flex;
  justify-content: space-between;
  padding-top: var(--spacing-md);
  border-top: 1px solid var(--border-color);
  margin-top: var(--spacing-xs);
  overflow: hidden;
  gap: 2px;
}

.x-label-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 60px;
  overflow: hidden;
}

.x-label {
  font-size: 0.7rem;
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.x-temp {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-secondary);
  white-space: nowrap;
}

/* Legend */
.chart-legend {
  display: flex;
  justify-content: center;
  gap: var(--spacing-lg);
  margin-top: var(--spacing-md);
  padding-top: var(--spacing-sm);
  border-top: 1px solid var(--border-color);
}

.legend-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}

.legend-line {
  width: 20px;
  height: 3px;
  border-radius: 2px;
}

.legend-line.main {
  background: linear-gradient(90deg, var(--accent-blue), var(--accent-cyan), var(--accent-orange));
}

.legend-line.high {
  background: var(--accent-orange);
  height: 2px;
  border-style: dashed;
}

.legend-line.low {
  background: var(--accent-blue);
  height: 2px;
  border-style: dashed;
}

.legend-line.humidity {
  background: var(--accent-green);
  height: 2px;
  border-style: dashed;
}

.legend-text {
  font-size: 0.75rem;
  color: var(--text-muted);
}

/* No Data State */
.no-data {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
}

.no-data-icon {
  font-size: 2.5rem;
  margin-bottom: var(--spacing-sm);
  opacity: 0.5;
}

/* Responsive */
@media (max-width: 600px) {
  .stats-row {
    grid-template-columns: repeat(2, 1fr);
  }

  .x-label-container:nth-child(even) {
    display: none;
  }

  .stat-icon {
    font-size: 1rem;
  }

  .stat-value {
    font-size: 0.9rem;
  }
}

@media (max-width: 400px) {
  .view-toggle {
    width: 100%;
  }

  .toggle-btn {
    flex: 1 1;
  }

  .chart-legend {
    flex-wrap: wrap;
    gap: var(--spacing-sm);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TemperatureTrend/TemperatureTrend.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;EAC/B,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,sCAAsC;EACtC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,sCAAsC;AACxC;;AAEA;EACE,mDAAmD;EACnD,sCAAsC;AACxC;;AAEA;;EAEE,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,IAAI;EACJ,YAAY;AACd;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,yCAAyC;EACzC,6BAA6B;EAC7B,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gGAAgG;AAClG;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;AACF","sourcesContent":[".temperature-trend {\n  padding: var(--spacing-lg);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: var(--spacing-md);\n  flex-wrap: wrap;\n  gap: var(--spacing-sm);\n  align-items: center;\n}\n\n.title-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.card-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.card-subtitle {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n/* View Toggle */\n.view-toggle {\n  display: flex;\n  background: var(--bg-secondary);\n  border-radius: var(--radius-sm); \n  padding: 2px;\n  border: 1px solid var(--border-color);\n}\n\n.toggle-btn {\n  padding: var(--spacing-xs) var(--spacing-sm);\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  font-size: 0.75rem;\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n  transition: all var(--transition-fast);\n  white-space: nowrap;\n  min-width: fit-content;\n}\n\n.toggle-btn:hover {\n  color: var(--text-primary);\n}\n\n.toggle-btn.active {\n  background: var(--accent-blue);\n  color: white;\n}\n\n/* History Range Selector */\n.history-range-selector {\n  display: flex;\n  gap: var(--spacing-xs);\n  margin-bottom: var(--spacing-md);\n}\n\n.range-btn {\n  padding: var(--spacing-xs) var(--spacing-md);\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  color: var(--text-muted);\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n  transition: all var(--transition-fast);\n}\n\n.range-btn:hover {\n  color: var(--text-primary);\n  border-color: var(--accent-cyan);\n}\n\n.range-btn.active {\n  background: var(--accent-cyan);\n  color: white;\n  border-color: var(--accent-cyan);\n}\n\n/* History Loading */\n.history-loading {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-sm) 0;\n  color: var(--text-muted);\n  font-size: 0.8rem;\n}\n\n.spinner.small {\n  width: 16px;\n  height: 16px;\n  border-width: 2px;\n}\n\n/* Statistics Row */\n.stats-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--spacing-sm);\n  margin-bottom: var(--spacing-md);\n}\n\n.stat-card {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-sm);\n  background: var(--bg-secondary);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-color);\n}\n\n.stat-card.trend.rising {\n  border-color: var(--accent-green);\n  background: rgba(16, 185, 129, 0.1);\n}\n\n.stat-card.trend.falling {\n  border-color: var(--accent-blue);\n  background: rgba(59, 130, 246, 0.1);\n}\n\n.stat-icon {\n  font-size: 1.25rem;\n}\n\n.stat-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.stat-value {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  line-height: 1.2;\n}\n\n.stat-label {\n  font-size: 0.65rem;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n/* Chart Container */\n.chart-container {\n  flex: 1;\n  display: flex;\n  gap: var(--spacing-sm);\n  min-height: 150px;\n}\n\n.y-axis {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: var(--spacing-sm) 0;\n  min-width: 40px;\n}\n\n.y-label {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  text-align: right;\n  font-family: 'Monaco', 'Consolas', monospace;\n}\n\n.chart-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.chart-svg {\n  flex: 1;\n  width: 100%;\n  overflow: visible;\n}\n\n/* Grid Lines */\n.grid-lines line {\n  stroke: var(--border-color);\n  stroke-width: 0.3;\n  stroke-dasharray: 2, 4;\n}\n\n/* Chart Paths */\n.area-path {\n  transition: d var(--transition-normal);\n}\n\n.temp-line {\n  filter: drop-shadow(0 0 4px rgba(6, 182, 212, 0.5));\n  transition: d var(--transition-normal);\n}\n\n.high-line,\n.low-line {\n  opacity: 0.7;\n}\n\n/* Data Points */\n.data-point-group {\n  transition: transform var(--transition-fast);\n}\n\n.data-point {\n  transition: r var(--transition-fast);\n}\n\n.point-glow {\n  transition: opacity var(--transition-fast), r var(--transition-fast);\n}\n\n.chart-svg:hover .data-point {\n  r: 2.5;\n}\n\n.chart-svg:hover .point-glow {\n  r: 5;\n  opacity: 0.5;\n}\n\n/* X-Axis */\n.x-axis {\n  display: flex;\n  justify-content: space-between;\n  padding-top: var(--spacing-md);\n  border-top: 1px solid var(--border-color);\n  margin-top: var(--spacing-xs);\n  overflow: hidden;\n  gap: 2px;\n}\n\n.x-label-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 0 1 auto;\n  min-width: 0;\n  max-width: 60px;\n  overflow: hidden;\n}\n\n.x-label {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.x-temp {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n/* Legend */\n.chart-legend {\n  display: flex;\n  justify-content: center;\n  gap: var(--spacing-lg);\n  margin-top: var(--spacing-md);\n  padding-top: var(--spacing-sm);\n  border-top: 1px solid var(--border-color);\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n}\n\n.legend-line {\n  width: 20px;\n  height: 3px;\n  border-radius: 2px;\n}\n\n.legend-line.main {\n  background: linear-gradient(90deg, var(--accent-blue), var(--accent-cyan), var(--accent-orange));\n}\n\n.legend-line.high {\n  background: var(--accent-orange);\n  height: 2px;\n  border-style: dashed;\n}\n\n.legend-line.low {\n  background: var(--accent-blue);\n  height: 2px;\n  border-style: dashed;\n}\n\n.legend-line.humidity {\n  background: var(--accent-green);\n  height: 2px;\n  border-style: dashed;\n}\n\n.legend-text {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n/* No Data State */\n.no-data {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n}\n\n.no-data-icon {\n  font-size: 2.5rem;\n  margin-bottom: var(--spacing-sm);\n  opacity: 0.5;\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n  .stats-row {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .x-label-container:nth-child(even) {\n    display: none;\n  }\n\n  .stat-icon {\n    font-size: 1rem;\n  }\n\n  .stat-value {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 400px) {\n  .view-toggle {\n    width: 100%;\n  }\n\n  .toggle-btn {\n    flex: 1;\n  }\n\n  .chart-legend {\n    flex-wrap: wrap;\n    gap: var(--spacing-sm);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
